<template>
    <vue-simple-suggest :list="getSuggestions" :filter-by-query="true" @select="addTag">
        <taggle-tags :tags="currentTags" :new-tags="newTags" @tag-update="updateTags" />
    </vue-simple-suggest>
</template>

<script>
import VueSimpleSuggest from './MySimpleSuggest.vue'
import tagComponent from './Tag.vue'

export default {
    components: {
        'taggle-tags': tagComponent,
        'vue-simple-suggest': VueSimpleSuggest,
    },
    props: {
        currentTags: {
            type: Array,
            required: true,
        },
        userTags: {
            type: Array,
            required: true,
        },
    },
    computed: {
        newTags: function() {
            let newTags = []
            for (let element of this.currentTags) {
                if (!this.userTags.includes(element)) {
                    newTags.push(element)
                }
            }
            return newTags
        }
    },
    methods: {
        getSuggestions: function() {
            let suggestions = []
            for (let element of this.userTags) {
                // Add to suggestions if not in current tags
                if (!this.currentTags.includes(element)) {
                    suggestions.push(element)
                }
            }
            return suggestions
        },
        addTag: function(suggestion) {
            if (suggestion != null) {
                this.currentTags.push(suggestion)
            }
        },
        updateTags: function(tags) {
            this.$emit('tag-update', tags)
        },
    }
}
</script>

<style>
.vue-simple-suggest.designed .suggestions {
    border-radius: 3px;
    border: 1px solid #aaa;
    background-color: #fff;
    opacity: 1;
    padding-left: 5px;
    padding-right: 5px;
}

.vue-simple-suggest.designed .suggestions .suggest-item {
    cursor: pointer;
    user-select: none;
    list-style-type: none;
}

.vue-simple-suggest.designed .suggestions .suggest-item,
.vue-simple-suggest.designed .suggestions .misc-item {
    padding: 5px 10px;
}

.vue-simple-suggest.designed .suggestions .suggest-item.hover {
    background-color: #2874D5 !important;
    color: #fff !important;
}

.vue-simple-suggest.designed .suggestions .suggest-item.selected {
    background-color: #2832D5;
    color: #fff;
}
</style>
